import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import { DxDataGridComponent, DxScrollViewComponent } from 'devextreme-angular';
import { GeneralService } from '../../../services/formulacion/general.service';
import { UtilHelper } from '../../../_helpers/util';
import { environment } from '../../../../environments/environment';
declare const toastr: any;

@Component({
  selector: 'app-revision-inicio',
  templateUrl: './revision-inicio.component.html',
  styles: []
})
export class RevisionInicioComponent implements OnInit {

    techos: any[];
    oTechos: any[];
    baseUrl = environment.apiEndpoint;
    techoId: number;
    popupVisibleEstado: boolean = false;
    popupVisibleO: boolean = false;
    rol: number = 0;
    constructor(private _gs: GeneralService) {
      this.getTechoByUO();      
    }
  
    ngOnInit() {
    }
  
    onToolbarPreparing(e) {
      e.toolbarOptions.items.unshift({
        location: 'before',      
      });
    }
  
    getTechoByUO() {
      let u = JSON.parse(localStorage.getItem('u'));
      if (u != null) {
        this._gs.getTechoByUO(u.unidad).subscribe(
          (response) => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {              
              this.techos = result.data;            
            } else {
              this.techos = [];
            }
          },
          (error) => { console.log('Error', error); });
      }
    } 
    
  }
  